import React from 'react';
// Screens
import ApplicantsScreen from '../../containers/Applicants';
import ApplicantDetailScreen from '../../containers/Applicants/Details';
import StudentsScreen from '../../containers/Students';
import StudentDetailScreen from '../../containers/Students/Details';
import AttendaneesScreen from "../../containers/Attendance";
import ClassesScreen from "../../containers/Classes";
import SubjectsScreen from "../../containers/Subjects";
import TeachersScreen from "../../containers/Teachers";
import TeacherDetailScreen from "../../containers/Teachers/Details";

// Applicants
const Applicants = {
    id: 'applicants',
    step: {
        id: 'applicants',
        path: '/dashboard/applicants',
        label: 'Applicants',
        Component: (props) => <ApplicantsScreen {...props} />,
    },
};

const ApplicantDetail = {
    id: 'applicant_detail',
    step: {
        id: 'applicant_detail',
        path: '/dashboard/applicants/detail',
        label: 'Applicant Detail',
        Component: (props) => <ApplicantDetailScreen {...props} />,
    },
};

// Students
const Students = {
    id: 'students',
    step: {
        id: 'students',
        path: '/dashboard/students',
        label: 'Students',
        Component: (props) => <StudentsScreen {...props} />,
    },
};

const StudentDetail = {
    id: 'student_detail',
    step: {
        id: 'student_detail',
        path: '/dashboard/students/detail',
        label: 'Student Detail',
        Component: (props) => <StudentDetailScreen {...props} />,
    },
};

// Attendance
const Attendance = {
    id: "attendance",
    step: {
        id: "attendance",
        path: "/dashboard/attendance",
        label: "Attendance",
        Component: (props) => <AttendaneesScreen {...props} />,
    },
}

// Teachers
const Teachers = {
    id: "teachers",
    step: {
        id: "teachers",
        path: "/dashboard/teachers",
        label: "Teachers",
        Component: (props) => <TeachersScreen {...props} />,
    },
}

const TeacherDetail = {
    id: "teacher_detail",
    step: {
        id: "teacher_detail",
        path: "/dashboard/teachers/detail",
        label: "Teacher Detail",
        Component: (props) => <TeacherDetailScreen {...props} />,
    },
}

// Classes
const Classes = {
    id: "classes",
    step: {
        id: "classes",
        path: "/dashboard/classes",
        label: "Classes",
        Component: (props) => <ClassesScreen {...props} />,
    },
}

// Subjects
const Subjects = {
    id: "subjects",
    step: {
        id: "subjects",
        path: "/dashboard/subjects",
        label: "Subjects",
        Component: (props) => <SubjectsScreen {...props} />,
    },
}

const AllSteps = [
    Applicants,
    ApplicantDetail,
    Students,
    StudentDetail,
    Attendance,
    Teachers,
    TeacherDetail,
    Classes,
    Subjects,
];

export default AllSteps;
